<template>
  <div>
    <AtomLoadingSecondary/>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionAssetSignedStudents',

  created () {
    this.$router.push(`/${this.$t('rPaths.asset')}/${this.$route.params.id}/${this.$t('mEditionMenu.asset.signedStudents.subject')}/${this.$t('mEditionMenu.asset.signedStudents.children.students.subedition')}`)
  }
}
</script>
